import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';
import { colors, unitConverter as uc } from '../../../styles/base';
import { Heading4 } from '../../atoms/Headings/Headings';
import BlockContentSection from '../../molecules/BlockContent/BlockContent';

const SubscriptionSideBar = ({ content }) => {
  const blockContentCss = css`
    margin: ${uc('20px 0 0 20px')};
    text-align: left;

    ${Heading4} {
      font-size: ${uc('17px')};

      &:nth-of-type(1) {
        color: ${colors.marigold};
      }

      &:nth-of-type(2) {
        color: ${colors.accent};
      }

      &:nth-of-type(3) {
        margin-bottom: ${uc('10px')};
        color: ${colors.mint};
      }
    }

    li {
      margin: ${uc('0 0 2px 20px')};
    }
  `;

  return (
    <div css={blockContentCss}>
      <BlockContentSection {...content.text} inSidebar />
    </div>
  );
};

/**
 * Prop types
 */
SubscriptionSideBar.propTypes = {
  content: PropTypes.shape({ text: {} }),
};

/**
 * Default props
 */
SubscriptionSideBar.defaultProps = {
  content: {},
};

export default SubscriptionSideBar;
